import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const _S3_PREFIX = "https://media.werz.at/community-assets/EKKO/"

const ekko: CommunityData = {
  code: "ekko",
  inviteCode: "ekko",
  name: "EKKO",
  thumbnail: "https://media.werz.at/community-assets/EKKO/web-logo.png",
  favicon: "",
  defaultCurrency: "SEK",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/ekk-018`,
  socials: {},
  styles: {
    global: {
      counterColor: "#ffffff",
      logo: {
        src: "https://media.werz.at/community-assets/EKKO/web-logo.png",
        styles: "w-[128px] h-[131px]",
      },
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/EKKO/web-alternative-logo.png",
        styles: "w-[128px] h-[131px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "",
      contentBg: "#000000",
      contentBoxShadow: "!rounded-[24px]",
      bgDesktop: "https://media.werz.at/community-assets/EKKO/web-background.mov?type=video",
      bgMobile: "https://media.werz.at/community-assets/EKKO/web-background.mov?type=video",
      mainFont: "font-['CravendRegular']",
      primaryButton:
        "bg-white border border-white px-[18px] py-[16px] !text-black font-['CravendRegular'] !text-[13px] text-left",
    },
    navigation: {
      iconsColor: "#fd38fd",
      sideBarSeparator: "",
      separator: "#333333",
      item: "text-[#fd38fd] font-['CravendRegular'] text-sm uppercase text-center gap-x-[10px] border-b border-[#333333] !py-2",
      itemSelected: "",
    },
    communityLanding: {
      container: "!bg-black !rounded-[24px] !pb-8",
      titles: "text-[#fd38fd] font-['CravendRegular'] text-xl uppercase text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle:
          "text-[#fd38fd] font-['CravendRegular'] text-xl uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-black",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full h-[256px] sm:h-[144px] bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#fd38fd] font-['CravendRegular'] text-base uppercase text-left leading-[110%]",
          subtitle:
            "text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%]",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0",
        sectionTitle:
          "text-[#fd38fd] font-['CravendRegular'] text-xl uppercase text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden",
          mediaContainer:
            "w-full sm:!w-[228px] h-[183px] sm:!h-[128px] sm:flex-shrink-0 relative overflow-hidden",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full h-full bg-gray-400",
          content: "flex flex-col px-0 sm:!px-4 py-4 sm:!py-0 bg-transparent p-4",
          title:
            "text-[#fd38fd] font-['F25BankPrinterRegular'] text-sm text-left leading-[110%] mb-2",
          subtitle:
            "text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%] !mb-1",
          location:
            "text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%] !mb-1",
          date: "text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%]",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#fd38fd] font-['CravendRegular'] text-lg uppercase text-left leading-[110%]",
        text: "text-white font-['F25BankPrinterRegular'] text-sm text-left leading-[110%]",
        customShopImageStyle: "border-black",
        sectionTitle:
          "text-[#fd38fd] font-['CravendRegular'] text-lg uppercase text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-black rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 border-black",
        title:
          "text-[#fd38fd] font-['CravendRegular'] text-xl uppercase text-left leading-[110%] mb-2",
        subtitle:
          "text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%] !mb-1",
        button:
          "bg-white border border-white px-[18px] py-[16px] !text-black font-['CravendRegular'] !text-[13px] text-left !my-1 !w-fit",
        questions: "text-xs text-left leading-[110%] text-[#37cd03]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#fd38fd] font-['CravendRegular'] text-lg uppercase text-left leading-[110%]",
        text: "text-white font-['F25BankPrinterRegular'] text-xs text-left leading-[110%]",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#fd38fd] font-['CravendRegular'] text-lg uppercase text-left leading-[110%]",
        text: "text-white font-['F25BankPrinterRegular'] text-xs text-left leading-[110%]",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#37cd03",
        mapStrokeColor: "#6d6d6d",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4 ",
        header: "text-[#fd38fd] font-['CravendRegular'] text-lg uppercase text-left leading-[110%]",
        text: "text-white font-['F25BankPrinterRegular'] text-xs text-left leading-[110%]",
      },
      tickets: {
        header:
          "text-[#fd38fd] font-['CravendRegular'] text-xl uppercase text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8",
        outerContainer: "flex flex-col !bg-black rounded-[24px] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto py-4 !border-b !border-[#333333] mb-4",
          media: "!hidden",
          name: "text-[#fd38fd] font-['F25BankPrinterRegular'] text-sm text-left leading-[110%]",
          description:
            "text-[#37cd03] font-['F25BankPrinterRegular'] text-xs text-left leading-[110%] !mt-1",
          price:
            "text-[#37cd03] font-['F25BankPrinterRegular'] text-sm text-left leading-[110%] !mt-1",
          quantity: "text-black font-['CravendRegular'] text-[11px] text-left",
          status: "text-[#37cd03] font-['F25BankPrinterRegular'] text-sm text-left leading-[110%]",
          counterContainer: "bg-white border border-white px-4 py-3 gap-x-4",
          button:
            "bg-white border border-white px-4 py-3 text-black font-['CravendRegular'] text-[11px] text-left !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default ekko
